var fetchUser;

fetchUser = {
  fetch: function(data, success, error) {
    var attributes, ref;
    data = data != null ? data.replace(/"/g, '') : void 0;
    attributes = {
      service: 'user',
      userId: data,
      country: document.head.getAttribute('data-country')
    };
    $.ajax({
      type: 'GET',
      url: ((ref = Groupon.endpoints) != null ? ref.user : void 0) || '/layout/calls/user',
      timeout: 5000,
      data: attributes,
      success: function(res) {
        var err, user;
        user = res.data, err = res.err;
        if (err) {
          return error(err);
        }
        if (!user) {
          return;
        }
        try {
          if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
            sessionStorage.setItem('verifiedUser', JSON.stringify(user));
          }
        } catch (error1) {}
        return success(user);
      },
      error: error
    });
  },
  getStoredUserData: function(noUser_cb, hasUser_cb) {
    var data, hasUserData, ref, user, userId;
    userId = (ref = Cookie.get('snickerdoodle')) != null ? ref.replace(/"/g, '') : void 0;
    hasUserData = false;
    if (!userId) {
      this.removeUserData;
      if (noUser_cb) {
        noUser_cb();
      }
    } else {
      if ((data = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem('verifiedUser') : void 0) != null) {
        try {
          user = JSON.parse(data);
        } catch (error1) {}
        if (user && typeof user === 'object') {
          if (hasUser_cb) {
            hasUser_cb(user);
          }
          hasUserData = true;
        }
      }
    }
    return {
      hasUserData: hasUserData,
      userId: userId
    };
  },
  removeUserData: function() {
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
        sessionStorage.removeItem('verifiedUser');
      }
    } catch (error1) {}
  }
};

module.exports = {
  fetchUser: fetchUser
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci91c2VyL2ZldGNoVXNlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3VzZXIvZmV0Y2hVc2VyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLFNBQUEsR0FDRTtFQUFBLEtBQUEsRUFBTyxTQUFDLElBQUQsRUFBTyxPQUFQLEVBQWdCLEtBQWhCO0FBQ0wsUUFBQTtJQUFBLElBQUEsa0JBQU8sSUFBSSxDQUFFLE9BQU4sQ0FBYyxJQUFkLEVBQW9CLEVBQXBCO0lBQ1AsVUFBQSxHQUFhO01BQ1gsT0FBQSxFQUFTLE1BREU7TUFFWCxNQUFBLEVBQVEsSUFGRztNQUdYLE9BQUEsRUFBUyxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQWQsQ0FBMkIsY0FBM0IsQ0FIRTs7SUFNYixDQUFDLENBQUMsSUFBRixDQUFPO01BQ0wsSUFBQSxFQUFNLEtBREQ7TUFFTCxHQUFBLDBDQUFzQixDQUFFLGNBQW5CLElBQTJCLG9CQUYzQjtNQUdMLE9BQUEsRUFBUyxJQUhKO01BSUwsSUFBQSxFQUFNLFVBSkQ7TUFLTCxPQUFBLEVBQVMsU0FBQyxHQUFEO0FBQ1AsWUFBQTtRQUFPLFdBQU4sSUFBRCxFQUFhO1FBQ2IsSUFBcUIsR0FBckI7QUFBQSxpQkFBTyxLQUFBLENBQU0sR0FBTixFQUFQOztRQUNBLElBQVUsQ0FBSSxJQUFkO0FBQUEsaUJBQUE7O0FBQ0E7O1lBQ0UsY0FBYyxDQUFFLE9BQWhCLENBQXdCLGNBQXhCLEVBQXdDLElBQUksQ0FBQyxTQUFMLENBQWUsSUFBZixDQUF4QztXQURGO1NBQUE7ZUFFQSxPQUFBLENBQVEsSUFBUjtNQU5PLENBTEo7TUFZTCxLQUFBLEVBQU8sS0FaRjtLQUFQO0VBUkssQ0FBUDtFQXdCQSxpQkFBQSxFQUFtQixTQUFDLFNBQUQsRUFBWSxVQUFaO0FBRWpCLFFBQUE7SUFBQSxNQUFBLG9EQUFvQyxDQUFFLE9BQTdCLENBQXFDLElBQXJDLEVBQTJDLEVBQTNDO0lBQ1QsV0FBQSxHQUFjO0lBSWQsSUFBRyxDQUFJLE1BQVA7TUFDRSxJQUFDLENBQUE7TUFDRCxJQUFlLFNBQWY7UUFBQSxTQUFBLENBQUEsRUFBQTtPQUZGO0tBQUEsTUFBQTtNQUlFLElBQUcsbUlBQUg7QUFDRTtVQUNFLElBQUEsR0FBTyxJQUFJLENBQUMsS0FBTCxDQUFXLElBQVgsRUFEVDtTQUFBO1FBR0EsSUFBRyxJQUFBLElBQVMsT0FBTyxJQUFQLEtBQWUsUUFBM0I7VUFDRSxJQUFvQixVQUFwQjtZQUFBLFVBQUEsQ0FBVyxJQUFYLEVBQUE7O1VBQ0EsV0FBQSxHQUFjLEtBRmhCO1NBSkY7T0FKRjs7QUFZQSxXQUFPO01BQ0wsYUFBQSxXQURLO01BRUwsUUFBQSxNQUZLOztFQW5CVSxDQXhCbkI7RUFnREEsY0FBQSxFQUFnQixTQUFBO0FBQ2Q7O1FBQ0UsY0FBYyxDQUFFLFVBQWhCLENBQTJCLGNBQTNCO09BREY7S0FBQTtFQURjLENBaERoQjs7O0FBcURGLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2YsV0FBQSxTQURlIn0=
